import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import logo from "../assets/logo/CIG_2601_Logo-01.png";
import { MdAccountCircle } from "react-icons/md";



function Navbar() {
    const [isVisible, setIsVisible] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menuTransition, setMenuTransition] = useState(false);
    const [hideLink, setHideLink] = useState(false);
    const [contrast, setContrast] = useState(false);

    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    const lastScrollY = useRef(window.scrollY);
   
    useEffect(() => {
        const handleScroll = () => {
            const isSmallDevice = window.innerWidth < 768;
            
            if (!isMenuOpen) {
                setIsVisible(window.scrollY < lastScrollY.current);
                lastScrollY.current = window.scrollY;

            }

            if (window.scrollY < 800) {
                setIsVisible(true);
            }

            if ((window.scrollY > 850 && !isSmallDevice) || (window.scrollY > 710 && isSmallDevice)) {
                setContrast(true);
            } else {
                setContrast(false);
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isMenuOpen]);


    useEffect(() => {
        if(!window.lenis) return;

        if (isMenuOpen) {
            window.lenis.stop();
        } else {
            window.lenis.start();
        }
    }, [isMenuOpen]);


    const handleMenuOpen = () => {
        setIsMenuOpen(true);
        setHideLink(false);

        setTimeout(() => {
            setMenuTransition(true);
        }, 1000);
    };

    const handleMenuClose = () => {
        setHideLink(true);

        setTimeout(() => {
            setMenuTransition(false);
            setIsMenuOpen(false);
        }, 900);

    };

    return (
        <>
         <div className={`fixed z-40 top-0 left-0 w-full transition-transform duration-300 bg-transparent
            ${isVisible ? 'translate-y-0' : '-translate-y-full'}
            ${contrast ? 'mix-blend-difference text-white' : 'text-white'}`}>
                <div className="flex justify-between items-center p-10">
                    <Link to="/" aria-label="Vai alla homepage di Careisgold">
                        <img src={logo} alt="Careisgold" className="w-32 md:w-56 z-40" />
                    </Link>

                    <div className="hidden xl:block">
                        <nav aria-label="Navigazione principale">
                            <ul className={`flex justify-center gap-6 items-center`}>
                                <li>
                                    <Link
                                        to="/"
                                        aria-current={isActive("/") ? "page" : undefined}
                                        className={`uppercase ${isActive('/') ? 'underline-animate-active' : 'underline-animate'}`}
                                    >
                                        Home
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/azienda/"
                                        aria-current={isActive("/azienda/") ? "page" : undefined}
                                        className={`uppercase ${isActive('/azienda/') ? 'underline-animate-active' : 'underline-animate'}`}
                                    >
                                        Azienda
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/prodotti-e-servizi/"
                                        aria-current={isActive("/prodotti-e-servizi/") ? "page" : undefined}
                                        className={`uppercase ${isActive('/prodotti-e-servizi/') ? 'underline-animate-active' : 'underline-animate'}`}
                                    >
                                        Prodotti
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/notizie/?section=approfondimenti"
                                        aria-current={isActive("/notizie/") ? "page" : undefined}
                                        className={`uppercase ${isActive('/notizie/') ? 'underline-animate-active' : 'underline-animate'}`}
                                    >
                                        Notizie
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/collabora-con-noi/"
                                        aria-current={isActive("/collabora-con-noi/") ? "page" : undefined}
                                        className={`uppercase ${isActive('/collabora-con-noi/') ? 'underline-animate-active' : 'underline-animate'}`}
                                    >
                                        Collabora con noi
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/faq/"
                                        aria-current={isActive("/faq/") ? "page" : undefined}
                                        className={`uppercase ${isActive('/faq/') ? 'underline-animate-active' : 'underline-animate'}`}
                                    >
                                        FAQ
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/contatti/"
                                        aria-current={isActive("/contatti/") ? "page" : undefined}
                                        className={`uppercase ${isActive('/contatti/') ? 'underline-animate-active' : 'underline-animate'}`}
                                    >
                                        Contatti
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        aria-current={isActive("/area-clienti-collaboratori/") ? "page" : undefined}
                                        to="/area-clienti-collaboratori/"
                                    >
                                        <MdAccountCircle className={`hover:text-[#b7955a] text-3xl ${isActive('/area-clienti-collaboratori/') ? 'text-gold' : ''}`}  />
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div className="block xl:hidden">
                        <button
                            type="button"
                            className="w-6 h-6"
                            onClick={handleMenuOpen}
                            aria-label="Apri il menu di navigazione"
                            aria-expanded={isMenuOpen}
                            aria-controls="mobile-menu"
                        >
                            <RxHamburgerMenu className="text-3xl text-gold" aria-hidden="true" focusable="false" />
                        </button>

                        <nav
                            id="mobile-menu"
                            aria-label="Navigazione mobile"
                            className={`z-40 flex flex-col justify-top items-center absolute top-0 right-0 w-full h-full transition-all duration-[1000ms] ease-in 
                                ${isMenuOpen ? 'opacity-100 bg-black' : 'opacity-0'} ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'} ${isMenuOpen && 'h-screen'}`}
                        >
                            {menuTransition && (
                                <>
                                    <ul className="flex flex-col gap-4 md:mt-[25%] mt-[40%] items-center w-full">
                                        <li>
                                            <Link
                                                to="/"
                                                aria-current={isActive("/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="250"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 mb-2 mt-36 ${isActive('/') ? 'text-gold' : ''}`}
                                            >
                                                Home
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/azienda/"
                                                aria-current={isActive("/azienda/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="500"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/azienda/') ? 'text-gold' : ''}`}
                                            >
                                                Azienda
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/prodotti-e-servizi/"
                                                aria-current={isActive("/prodotti-e-servizi/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="750"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/prodotti-e-servizi/') ? 'text-gold' : ''}`}
                                            >
                                                Prodotti
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/notizie/?section=approfondimenti"
                                                aria-current={isActive("/notizie/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="1000"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/notizie/') ? 'text-gold' : ''}`}
                                            >
                                                Notizie
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/collabora-con-noi/"
                                                aria-current={isActive("/collabora-con-noi/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="1250"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/collabora-con-noi/') ? 'text-gold' : ''}`}
                                            >
                                                Collabora con noi
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/faq/"
                                                aria-current={isActive("/faq/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="1500"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/faq/') ? 'text-gold' : ''}`}
                                            >
                                                FAQ
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/contatti/"
                                                aria-current={isActive("/contatti/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="1750"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/contatti/') ? 'text-gold' : ''}`}
                                            >
                                                Contatti
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/area-clienti-collaboratori/"
                                                aria-current={isActive("/area-clienti-collaboratori/") ? "page" : undefined}
                                                data-aos="fade-right"
                                                data-aos-duration="1750"
                                                className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/area-clienti-collaboratori/') ? 'text-gold' : ''}`}
                                            >
                                                Login
                                            </Link>
                                        </li>
                                    </ul>

                                    <button
                                        type="button"
                                        className="absolute top-0 right-0 w-6 h-6 text-white m-10"
                                        onClick={handleMenuClose}
                                        aria-label="Chiudi il menu di navigazione"
                                    >
                                        <IoClose className="text-3xl text-gold" aria-hidden="true" focusable="false" />
                                    </button>
                                </>
                            )}
                        </nav>
                    </div>
                </div>
        </div>
        </>
    );
}

export default Navbar;